export default {
  loading: {
    text: "拼命加載中",
  },
  filters: {
    time: "時間",
    startDate: "開始時間",
    endDate: "結束時間",
    addressSearch: "地址搜索",
    searchCounterpartyAddress: "搜索交易對手地址",
    currency: "幣種",
    selectCurrency: "請選擇幣種",
    amount: "數量",
    minAmount: "最小數量",
    maxAmount: "最大數量",
    maxAmountError: "最小數量不能大於最大數量",
    hideZeroTransactions: "隱藏數量為0的交易",
  },
  actions: {
    reset: "重置",
    query: "查詢",
  },
  table: {
    totalPrefix: "共計",
    totalSuffix: "條數據",
    download: "下載",
    empty: "暫無數據",
    bigAddressEmpty: "當前地址交易過多，請篩選後查看",
    transactionHash: "交易哈希",
    sender: "發送方",
    receiver: "接收方",
    currency: "幣種",
    transactionAmount: "交易數量",
    transactionTime: "交易時間",
  },
  directionOptions: {
    ALL: "全部",
    SENDER: "發送方",
    RECEIVER: "接收方",
  },
};
